import { api, LightningElement } from "lwc";

export default class extends LightningElement {
  @api count: string | number | null = null;
  @api variant: "brick" | "tile" = "brick";

  private get stencilCount() {
    switch (typeof this.count) {
      case "number":
        return this.count;
      case "string":
        return parseInt(this.count, 10);
      default:
        return 3;
    }
  }

  private get stencils() {
    return Array.from({ length: this.stencilCount }).map((_, i) => ({
      key: `stencil-${i}`,
    }));
  }
}
